import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Settings } from '../../../core/models/app.settings.model';
import { AppSettings } from '../../../core/models/app.settings';

@Component({
  selector: 'app-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss'],
})
export class NotAuthorizedComponent implements OnInit {
  public form: FormGroup;
  public settings: Settings;
  constructor(public appSettings: AppSettings, public router: Router, public fb: FormBuilder) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.form = this.fb.group({
      param: [null, Validators.required],
    });
  }

  public onSubmit(values: Object): void {
    if (this.form.valid) {
      this.router.navigate(['/search', values['param']]);
    }
  }

  public goHome(): void {
    this.router.navigate(['/home']);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.settings.loadingSpinner = false;
    });
  }
}
